import React, { useState } from 'react';
import { connect } from 'react-redux';
import '../../assets/css/servermanagement.css';
import { useEffect } from 'react';
import { ChevronLeft, FileCopy, Payment, PlaceRounded, PlayArrow, ShowChart, StorageOutlined, SupervisedUserCircle, Work } from '@material-ui/icons';
// import Schedule from './EditSchedule/Schedule';
import ApiConnect from '../common/ApiConnect';
import { Footer } from '../common/Footer';
import GenWiz from '../common/Popups/Genwizui';
import FormView from '../common/CommonComponents/FormView';
import base from '../../config';
import FormEdit from '../common/CommonComponents/FormEdit';

const ServerManagement = ({
  isloading
}) => {
  //genwizard ui
  const [gwconfig, setgenwiz] = useState({ stateFunction: setgenwiz });
  //redux state
  const [activeTab, setActiveTab] = useState('Container');
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [itemData, setItemData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [showTermination, setShowTermination] = useState(false);
  const [showOpenAiDetails, setShowOpenAiDetails] = useState(false);
  const [openAiData, setOpenAiData] = useState({})
  const [showSched, setShowSched] = useState(false);
  const [serverList, setServerList] = useState([]);
  const [serverTerminationList, setServerTerminationList] = useState([]);
  const [tempList, setTempList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [serverSelected, setServerSelected] = useState([]);
  const [filters, setFilters] = useState({
    caas_orderItemUid: '',
    caas_clientName: '',
    caas_environment: '',
    caas_region: '',
    caas_state: '',
    caas_camEnv: '',
    caas_vendorName: ''
  });

  const toggleRow = (id) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedRows(newExpanded);
  };

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
  };

  const resetFilters = () => {
    setFilters({
      // privateDNSName: '',
      // orderid: '',
      // clientname: '',
      // environment: '',
      // regionAlias: '',
      // instanceState: '',
      // platformtype: 'dedicated',
      // InstanceType: '',
      // accountType: '',
      // assetname: ''
    });

    const fields = document.querySelectorAll('.filter-input');
    fields.forEach((item) => {
      item.value = '';
    })
  };

  const getStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'running':
        return 'badge-running';
      case 'terminated':
      case 'terminating':
        return 'badge-terminated';
      case 'stopped':
      case 'stopping':
        return 'badge-stopped';
      default:
        return '';
    }
  };

  const setFormData = (item) => {
    setShowForm(true);
    let alterData = { ...item };
    const [year, month, day] = item['caas_sed'].split('T')[0].split('-');
    alterData.caas_sed = `${year}-${month}-${day}`;
    //change the environment data to to lowercase
    alterData.caas_environment = item['caas_environment'].toLowerCase();
    setItemData(alterData);
  }

  const setTerminationData = (item) => {
    setServerSelected(item);
    setShowTermination(true);
    let alterData = { ...item };
    setItemData(alterData);
  }

  const setSelectServer = (item) => {
    const value = item.value
    let appCore = [...serverTerminationList];
    if (item.checked === true) {
      if (!appCore.includes(value)) {
        appCore.push(value)
      }
    } else {
      appCore = appCore.filter(val => val !== value);
    }
    setServerTerminationList(appCore);
  }

  // const setPopUp = (item) => {
  //   setgenwiz({
  //     appName: 'gwForm',
  //     config: {
  //       height: 'auto',
  //       stateFunction: setgenwiz,
  //       text: 'User Notes',
  //       type: 'textarea',
  //       bntSubmit: async (data) => { }
  //     },
  //   });
  // }
  const setPopUp = () => {
    setgenwiz({
      appName: 'gwConfirm',
      config: {
        stateFunction: setgenwiz,
        text: (<>Are you sure want to Terminate<br /><span style={{ fontWeight: '500', color: '#761EA0' }}>{serverTerminationList.join(',')}</span></>),
        onloop: true,
        width: 360,
        height: 220,
        bntYes: () => {
          terminateInstance();
        }
      },
    });
  }

  const tableButton = (evt) => {
    evt.stopPropagation();
    const curdiv = evt.target.closest("td").querySelector(".table-menu");
    if (curdiv.style.display === "block") {
      curdiv.style.display = "none";
    } else {
      const alldiv = document.getElementsByClassName("table-menu");
      for (let i = 0; i < alldiv.length; i++) alldiv[i].style.display = "none";
      curdiv.style.display = "block";
    }
  };

  //fetch the data on api gateway
  const fetchData = () => {
    const idToken = localStorage.getItem("token");
    ApiConnect.get(
      'fui/orders/genwizard4', {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    }
    ).then(resp => {
      if(resp.data.length === 0)
        setIsLoading(false);
      else
        setTempList(resp.data);
    }).catch(err => {
      setIsLoading(false);
      console.log(err);
    })
  }
  //copy test
  const copyText = (cpId, text) => {
    //const toastid = document.getElementById('gw-toast')
    navigator.clipboard.writeText(text)
      .then(() => {
        const copyDsp = document.querySelectorAll('.gw-copydsp');
        copyDsp.forEach(elem => {
          elem.style.display = 'none'
        });
        const dspCopy = document.getElementById(cpId)
        dspCopy.style.display = 'block';
        setTimeout(() => {
          dspCopy.style.display = 'none';
        }, 3000);
      })
      .catch(err => {
        console.error('Failed to copy key:', err);
      });
  }
  //new tab genwizard ai
  const genwizardAI = (contractid, environment) => {
    //init loading
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Fetching Data',
      }
    });
    //fetch data
    const idToken = localStorage.getItem("token");
    ApiConnect.get(
      `${base.app.apiSite}azure/openai-access/read/fetch?contractid=${contractid}&environment=${environment}`, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    }
    ).then(resp => {
      setOpenAiData(resp.data[0]);
      //hide loading
      setgenwiz({
        status: 'hide'
      });
    }).catch(err => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Error Terminating on Instance(s)',
          callback: () => { }
        }
      });
    })
  }

  //new tab genwizard ai
  const terminateInstance = () => {
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Please wait',
      }
    });
    const idToken = localStorage.getItem("token");
    const dataPost = {
      "caasid": serverSelected.caas_id,
      "customereid": serverSelected.caas_customerEID,
      "appcore": serverTerminationList.join(','),
      "orderid": serverSelected.caas_orderItemUid,
      "dcr": serverSelected.caas_dcr
    }
    ApiConnect.post(
      `${base.app.apiSite}provision/caas/terminate`,
      dataPost,
      {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": idToken,
        }
      }
    ).then(resp => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Data Updated',
          callback: () => {
            setgenwiz({
              appName: 'gwLoading',
              config: {
                stateFunction: setgenwiz,
                text: 'Reloading Data',
              }
            });
            fetchData();
            setServerTerminationList([])
          }
        }
      });
    }).catch(err => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Error Fetching OpenAi Details',
          callback: () => { }
        }
      });
    })
  }

  // useEffect(() => {
  //   if (activeTab === 'dedicated')
  //     setFilters({ ...filters, platformtype: activeTab, InstanceType: '' });
  //   else
  //     setFilters({ ...filters, platformtype: '', InstanceType: 'Container' });

  //   fetchData();
  // }, [activeTab]);

  useEffect(() => {
    setTimeout(() => {
      fetchData();
    }, 5000);
  }, [])


  useEffect(() => {
    // console.log(tempList.length)
    const servers = tempList.filter(item =>
      Object.entries(filters).every(([key, value]) => {
        if (!value) return true;

        if (typeof item[key] === "string") {
          if (key !== 'caas_camEnv')
            return item[key].toLowerCase().includes(value.toLowerCase());
          return item[key].toLowerCase() === value.toLowerCase()
        }

        return item[key] === value;
      })
    );
    setServerList(servers);
   
  }, [tempList, filters]);
  
  useEffect(() => {
    if(tempList.length > 0)
      setIsLoading(false);
  },[serverList])

  useEffect(() => {
    if (Object.entries(openAiData).length > 0) {
      setgenwiz({
        status: 'hide'
      });
      setShowOpenAiDetails(true);
    }
  }, [openAiData])

  return (
    <>
      <div className="genwizard4">
        <div className="header">
          <div className="tabs">
            {/* <button
              className={`tab ${activeTab === 'dedicated' ? 'active' : ''}`}
              onClick={() => setActiveTab('dedicated')}
            >
              DEDICATED
            </button> */}
            <button
              className={`tab ${activeTab === 'Container' ? 'active' : ''}`}
              onClick={() => setActiveTab('Container')}
            >
              CONTAINER
            </button>
            <div className="filter-actions">
              <button className="btn btn-secondary" onClick={() => {
                resetFilters();
              }}>
                Reset Filter
              </button>
              <button className="btn btn-primary" onClick={() => {
                fetchData();
                setIsLoading(true);
              }}>
                Refresh Data
              </button>
            </div>
          </div>
        </div>
        {/* <div className="box01" style={{ border: 'none', boxShadow: 'none', width: '100%', height: '100px', margin: '0px 0 20px 0' }}>
          <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0' }}>
            <div style={{ display: 'flex', width: '32%', height: '90%', padding: '10px 10px', margin: '0 20px 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Work style={{ float: 'left', width: '25px', height: '25px', padding: '10px', borderRadius: '10px', backgroundColor: 'rgba(79, 36, 154, 0.13)', color: '#7C3AED', border: '1px solid #EBEBEB' }} />
              </div>
              <div style={{ display: 'block' }}>
                <span className='title-task' style={{ fontSize: '2.8rem', margin: '10xp 10px 0 10px' }}>15</span>
                <span className='title-task' style={{ width: '100%', fontSize: '.9rem', margin: '0 15px' }}>Server Count</span>
              </div>
            </div>
            <div style={{ display: 'flex', width: '32%', height: '90%', padding: '10px 10px', margin: '0 20px 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ShowChart style={{ float: 'left', width: '25px', height: '25px', padding: '10px', borderRadius: '10px', backgroundColor: 'rgba(79, 36, 154, 0.13)', color: '#7C3AED', border: '1px solid #EBEBEB' }} />
              </div>
              <div style={{ display: 'block' }}>
                <span className='title-task' style={{ fontSize: '2.8rem', margin: '10xp 10px 0 10px' }}>10</span>
                <span className='title-task' style={{ width: '100%', fontSize: '.9rem', margin: '0 15px' }}>Server Running</span>
              </div>
            </div>
            <div style={{ display: 'flex', width: '32%', height: '90%', padding: '10px 10px', margin: '0 20px 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PlaceRounded style={{ float: 'left', width: '25px', height: '25px', padding: '10px', borderRadius: '10px', backgroundColor: 'rgba(79, 36, 154, 0.13)', color: '#7C3AED', border: '1px solid #EBEBEB' }} />
              </div>
              <div style={{ display: 'block' }}>
                <span className='title-task' style={{ fontSize: '2.8rem', margin: '10xp 10px 0 10px' }}>12</span>
                <span className='title-task' style={{ width: '100%', fontSize: '.9rem', margin: '0 15px' }}>Server Region</span>
              </div>
            </div>
            <div style={{ display: 'flex', width: '32%', height: '90%', padding: '10px 10px', margin: '0 0 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Payment style={{ float: 'left', width: '25px', height: '25px', padding: '10px', borderRadius: '10px', backgroundColor: 'rgba(79, 36, 154, 0.13)', color: '#7C3AED', border: '1px solid #EBEBEB' }} />
              </div>
              <div style={{ display: 'block' }}>
                <span className='title-task' style={{ fontSize: '2.8rem', margin: '10xp 10px 0 10px' }}>2</span>
                <span className='title-task' style={{ width: '100%', fontSize: '.9rem', margin: '0 15px' }}>Server Type</span>
              </div>
            </div>
          </div>
        </div> */}
        <div className="filter-section">
          <div className="filter-grid">
            {activeTab === 'dedicated' && (
              <div className="filter-item">
                <input
                  type="text"
                  className="filter-input"
                  placeholder="Filter by Private DNS..."
                  value={filters.privateDns}
                  disabled={isloading}
                  onChange={(e) => handleFilterChange('privateDNSName', e.target.value)}
                />
              </div>
            )}
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Product Name..."
                value={filters.caas_productName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_productName', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Order ID..."
                value={filters.caas_orderItemUid}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_orderItemUid', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Client Name..."
                value={filters.caas_clientName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_clientName', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_vendorName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_vendorName', e.target.value)}
              >
                <option value="">All Vendors</option>
                <option value="CAM">CAM</option>
                <option value="Marketplace">Market Place</option>
              </select>
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_environment}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_environment', e.target.value)}
              >
                <option value="">All Environments</option>
                <option value="prod">Production</option>
                <option value="test">Test</option>
                <option value="dev">Development</option>
              </select>
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Region..."
                value={filters.caas_region}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_region', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_state}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_state', e.target.value)}
              >
                <option value="">All Status</option>
                <option value="running">Running</option>
                <option value="stopped">Stopped</option>
                <option value="terminated">Terminated</option>
                <option value="terminating">Terminating</option>
              </select>
            </div>
          </div>
        </div>

        <div className="table-container">
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  {activeTab === 'dedicated' &&
                    (<th>Private DNS</th>)
                  }
                  <th>Product Name</th>
                  <th>Order ID</th>
                  <th>Client Name</th>
                  <th>Vendor Name</th>
                  <th>Environment</th>
                  <th>Region</th>
                  <th>Service End Date</th>
                  <th>Status</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ?
                  <React.Fragment>
                    {Array.from({ length: activeTab === 'dedicated' ? 10 : 9 }).map((_, j) => (
                      <tr className='skeleton'>
                        {Array.from({ length: activeTab === 'dedicated' ? 9 : 8 }).map((_, j) => (
                          <td><span>*******************</span></td>
                        ))}
                        <td style={{ height: '30px' }}><span>*****</span></td>
                      </tr>
                    ))}
                  </React.Fragment>
                  : serverList.length > 0 ?
                    <>
                      {serverList.map((server) => (
                        <>
                          <tr
                            className={expandedRows.has(server.caas_id) ? 'expanded' : ''}
                            onClick={() => toggleRow(server.caas_id)}
                          >
                            {activeTab === 'dedicated' &&
                              (<td><span className="private-dns">{server.privateDNSName}</span></td>)
                            }
                            <td>{server.caas_productName}</td>
                            <td>{server.caas_orderItemUid}</td>
                            <td><span className="client-name">{server.caas_clientName}</span></td>
                            <td><span className="badge badge-env">{server.caas_vendorName}</span></td>
                            <td><span className="badge badge-env">{server.caas_environment}</span></td>
                            <td>{server.caas_region}</td>
                            <td>{server.caas_sed}</td>
                            <td>
                              <span className={`badge ${getStatusBadgeClass(server.caas_state)}`}>
                                {server.caas_state}
                              </span>
                            </td>
                            <td>
                              <button className="action-btn"><ChevronLeft style={{ transform: !expandedRows.has(server.caas_id) ? 'rotate(-90deg)' : 'rotate(90deg)' }} /></button>
                            </td>
                          </tr>
                          <tr className={`details-row ${!expandedRows.has(server.caas_id) ? 'hidden' : ''}`}>
                            <td colSpan="10">
                              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ width: '98%', display: 'flex' }}>
                                  <div style={{ width: '100%', border: '1px solid #BEBEBE', display: 'flex-inline', padding: '20px', textAlign: 'left', borderRadius: '8px 8px', backgroundColor: '#FFFFFF' }}>
                                    <table className='innerserverdetails'>
                                      <tbody>
                                        <tr>
                                          <td>Access Link URL:</td>
                                          <td>
                                            {
                                              server.caas_alinkURL != "" ?
                                                <>
                                                  {
                                                    server.caas_alinkURL.split(",").map(item => {
                                                      const subd = item.indexOf('cui-') >= 0 ? "/chatbot" : item.indexOf('iam-') >= 0 ? "/iam" : "";

                                                      return (
                                                        <>
                                                          <a className='accessLink' href={'https://' + item + subd} target='_blank'>https://{item + subd}</a>
                                                          <br />
                                                        </>
                                                      )
                                                    })
                                                  }
                                                </>
                                                :
                                                <>
                                                  Not Available
                                                </>
                                            }</td>
                                          <td>Domain Context Root:</td>
                                          <td></td>
                                        </tr>
                                        {/* <tr>
                                        <td>Instance ID:</td>
                                        <td>{server.instanceId}</td>
                                        <td>Instance State:</td>
                                        <td>{server.instanceState}</td>
                                      </tr> */}
                                        <tr>
                                          <td>Product UID:</td>
                                          <td>{server.caas_productUId}</td>
                                          <td>App Core:</td>
                                          <td>{server.caas_appcore}</td>
                                        </tr>
                                        <tr>
                                          <td>Cluster ID:</td>
                                          <td>{server.caas_dcr}</td>
                                          <td>App Agent:</td>
                                          <td>{server.caas_appagent}</td>
                                        </tr>
                                        <tr>
                                          <td>Customer Enterprise ID:</td>
                                          <td>{server.caas_customerEID}</td>
                                          <td>Secondary POC:</td>
                                          <td>{server.caas_secondaryPOC}</td>
                                        </tr>
                                        <tr>
                                          <td>Project Name:</td>
                                          <td>{server.caas_projectName}</td>
                                          <td>WBSE Code:</td>
                                          <td>{server.caas_wbsecode}</td>
                                        </tr>
                                        <tr>
                                          <td>Notes:</td>
                                          <td>{server.caas_notes}</td>
                                          <td>Date Started:</td>
                                          <td>{server.caas_dateInsert}</td>
                                        </tr>
                                        <tr>
                                          <td>AI Info:</td>
                                          <td><button className='buttonActions' style={{ width: 'auto', margin: '0', padding: '5px 8px' }} onClick={() => genwizardAI(server.caas_contractID, server.caas_environment)}>Genwizard AI</button></td>
                                          <td>&nbsp;</td>
                                          <td>&nbsp;</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr className={`details-row ${!expandedRows.has(server.caas_id) ? 'hidden' : ''}`} style={{ border: 'none' }}>
                            <td colSpan="10" style={{ textAlign: 'right' }}>
                              <div style={{ marginRight: '18px', position: 'relative' }}>
                                {/* {activeTab === 'dedicated' &&
                                <button type="button" className='buttonActions' onClick={() => setShowSched(true)}>Schedule</button>
                              } */}
                                <button type="button" className='buttonActions' onClick={() => setFormData(server)}>Edit Tags</button>
                                <button type="button" className='buttonActions' onClick={(e) => setTerminationData(server)}>Terminate</button>
                                {/* <button type="button" className='buttonActions' onClick={(e) => tableButton(e)}>Actions</button>
                                <div className="table-menu" style={{ display: "none", right: '0px', top: '-120px' }}>
                                  <ul>
                                    <li onClick={() => { }}>Connect</li>
                                    <li onClick={() => { }} style={{color:'#EBEBEB'}}>Start</li>
                                    <li onClick={() => { }} style={{color:'#EBEBEB'}}>Stop</li>
                                    <li onClick={() => { }}>Terminate</li>
                                  </ul>
                                  <div className="tri2"></div>
                                </div> */}
                              </div>
                            </td>
                          </tr>
                        </>
                      ))}
                    </> :
                    <tr style={{border:'none'}}>
                      <td colSpan="10">
                        <div style={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <div style={{ textAlign: 'center' }}>
                            <h2 style={{ fontSize: '1.8rem', color: '#333333', fontWeight: '600' }}>No data found</h2>
                            <span>Try to click button the Refresh Data</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <FormEdit show={showForm} title={"Edit Tags"} width={'550px'} height={'80%'} setShow={setShowForm} saveDisabled={true}>
        <div>
          <form id='editTags' className='formDataEdit'>
            <div className='formInputs'>
              <label>Customer Enterprise ID:</label>
              <input type="text" name="customerEnterpriseId" value={itemData.caas_customerEID} />
            </div>
            <div className='formInputs'>
              <label>Secondary POC:</label>
              <input type="text" name="secondaryPOC" value={itemData.caas_secondaryPOC} />
            </div>
            <div className='formInputs'>
              <label>Environment:</label>
              <select type="text" name="environment" value={itemData.caas_environment}>
                <option value="production">Production</option>
                <option value="dev">Dev</option>
                <option value="uat">Uat</option>
                <option value="sales">Sales</option>
                <option value="test">Test</option>
              </select>
            </div>
            <div className='formInputs'>
              <label>Initiative:</label>
              <select type="text" name="initiatives" value={itemData.caas_intiative}>
                <option value="Agile Capability">Agile Capability</option>
                <option value="Change Enablement">Change Enablement</option>
                <option value="FORM, Methods & Estimators">FORM, Methods & Estimators</option>
                <option value="Language Translation Services">Language Translation Services</option>
                <option value="Living Systems Advisory">Living Systems Advisory</option>
                <option value="1AAA">1AAA</option>
                <option value="DevOps Capability">DevOps Capability</option>
                <option value="ICS">ICS</option>
                <option value="IEMP">IEMP</option>
                <option value="myDiagnostic">myDiagnostic</option>
                <option value="myIndustry">myIndustry</option>
                <option value="myMDI">myMDI</option>
                <option value="myNav">myNav</option>
                <option value="mySP">mySP</option>
                <option value="myWizard Apps">myWizard - Other Apps</option>
                <option value="myWizard AI Apps">myWizard AI Apps</option>
                <option value="myWizard_AiOps">Mywizard AiOps</option>
                <option value="myWizard Governance">Mywizard Governance</option>
                <option value="myWizard Platform Mgt">Mywizard Platform Mgt</option>
                <option value="myWizard SaaS">myWizard SaaS</option>
                <option value="myWizard SI">myWizard SI</option>
                <option value="Technical architecture">Technical architecture</option>
                <option value="Transformation Office">Transformation Office</option>
                <option value="UX">UX</option>
                <option value="Automation Deployment">Automation Deployment</option>
                <option value="Sales & Solutions">Automation Sales & Solution</option>
                <option value="PMO">PMO</option>
              </select>
            </div>
            <div className='formInputs'>
              <label>WBSE Code:</label>
              <input type="text" name="wbseCode" value={itemData.caas_wbsecode} />
            </div>
            <div className='formInputs'>
              <label>Service End Date:</label>
              <input type="date" name="serviceEndDate" value={itemData.caas_sed} />
            </div>
            <div className='formInputs'>
              <label>Project Name:</label>
              <input type="text" name="projectName" value={itemData.caas_projectName} />
            </div>
            <div className='formInputs' style={{ height: '80px' }}>
              <label>Notes:</label>
              <textarea type="text" name="notes">{itemData.caas_notes}</textarea>
            </div>
          </form>
        </div>
      </FormEdit>
      {/* termination component */}
      <FormEdit show={showTermination} title={"Select Instance"} width={'420px'} height={'340px'} setShow={setShowTermination} saveTitle={'Delete'} saveFunction={setPopUp}>
        <div>
          <form id='editTags' className='formDataEdit'>
            {itemData.caas_appcore && (
              itemData.caas_appcore.split(',').map((item, cntr) => (
                <div className='instanceDisplay'>
                  <input type="checkbox" name={item} value={item}
                    onChange={(e) => setSelectServer(e.target)}
                    style={{ margin: '5px 10px', accentColor: '#7500C0' }}
                    disabled={item === 'AM' ? true : false}
                  />
                  <StorageOutlined style={{ color: '#7500C0', width: '30px' }} />
                  <label style={{ marginLeft: '10px', fontSize: '.9rem' }}>{item}</label>
                  <label style={{ position: 'absolute', right: '10px', fontSize: '.8rem' }}>Running</label>
                </div>
              ))
            )
            }
          </form>
        </div>
      </FormEdit>
      {/* openai details */}
      <FormView show={showOpenAiDetails} title={"LLM Details"} width={'550px'} height={'80%'} setShow={setShowOpenAiDetails}>
        <div style={{ padding: '10px 20px', fontSize: '9px !important' }}>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>OpenAIServiceName</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '10px', borderRadius: '4px' }}>
              <span style={{ fontSize: '1rem !important', }}>{openAiData['OpenAIServiceName']}</span>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>OpenAIEndPoint</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '10px', borderRadius: '4px' }}>
              <span style={{ fontSize: '1rem !important', }}>{openAiData['OpenAIEndPoint']}</span>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>OpenAIKey</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '10px', borderRadius: '4px', wordBreak: 'break-word' }}>
              {openAiData['OpenAIKey'] &&
                <>
                  <span className="key-prefix">{openAiData['OpenAIKey'].substring(0, 7)}</span>
                  <span className="key-mask">••••••••••••••••••••••••••••••••</span>
                  <span className="key-suffix">{openAiData['OpenAIKey'].substring(openAiData['OpenAIKey'].length - 4)}</span>
                </>
              }
              <>
                <div className='gw-copydsp' id={'cp01'}><span>Copied</span><div className="tri"></div></div>
                <button className='gw-copybtn' title="Copy Text" onClick={() => copyText('cp01', openAiData['OpenAIKey'])} style={{ width: '30px', height: '30px', fontSize: '.8rem', verticalAlign: 'middle', margin: '-5px 0 0 10px' }}>
                  <FileCopy style={{ width: '15px' }} />
                </button>
              </>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>SPID</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px', wordBreak: 'break-word' }}>
              {openAiData['SPID'] &&
                <>
                  <span className="key-prefix">{openAiData['SPID'].substring(0, 7)}</span>
                  <span className="key-mask">••••••••••••••••••••••••••••••••</span>
                  <span className="key-suffix">{openAiData['SPID'].substring(openAiData['SPID'].length - 4)}</span>
                </>
              }
              <>
                <div className='gw-copydsp' id={'cp02'}><span>Copied</span><div className="tri"></div></div>
                <button className='gw-copybtn' title="Copy Text" onClick={() => copyText('cp02', openAiData['SPID'])} style={{ width: '30px', height: '30px', fontSize: '.8rem', verticalAlign: 'middle', margin: '-5px 0 0 10px' }}>
                  <FileCopy style={{ width: '15px' }} />
                </button>
              </>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>SPSecretKey</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '15px 10px', borderRadius: '4px', fontSize: '1rem !important' }}>
              {openAiData['SPSecretKey'] &&
                <>
                  <span className="key-prefix">{openAiData['SPSecretKey'].substring(0, 7)}</span>
                  <span className="key-mask">••••••••••••••••••••••••••••••••</span>
                  <span className="key-suffix">{openAiData['SPSecretKey'].substring(openAiData['SPSecretKey'].length - 4)}</span>
                </>
              }
              <>
                <div className='gw-copydsp' id={'cp03'}><span>Copied</span><div className="tri"></div></div>
                <button className='gw-copybtn' title="Copy Text" onClick={() => copyText('cp03', openAiData['SPSecretKey'])} style={{ width: '30px', height: '30px', fontSize: '.8rem', verticalAlign: 'middle', margin: '-5px 0 0 10px' }}>
                  <FileCopy style={{ width: '15px' }} />
                </button>
              </>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Instance IP / URL</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px', whiteSpace: "pre-line" }}>
              <span style={{ fontSize: '1rem !important', }}>{
                openAiData['InstanceIP'] && openAiData['InstanceIP'].split(',').join('\n')}</span>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>ClientName</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
              <span style={{ fontSize: '1rem !important', }}>{openAiData['ClientName']}</span>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>CustomerEnterpriseID</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
              <span style={{ fontSize: '1rem !important', }}>{openAiData['CustomerEnterpriseID']}</span>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Order ID</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
              <span style={{ fontSize: '1rem !important', }}>{openAiData['OrderId']}</span>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Environment</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
              <span style={{ fontSize: '1rem !important', }}>{openAiData['Environment']}</span>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Deployment ID</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px' }}>
              <span style={{ fontSize: '1rem !important', }}>{openAiData['DeploymentID']}</span>
            </div>
          </div>
          <div style={{ width: '100%', height: 'auto', textAlign: 'left', margin: '10px 0' }}>
            <span style={{ color: '#7500C0', fontWeight: 'bold' }}>Deployment Name</span>
            <div style={{ marginTop: '10px', width: 'calc(100% - 20px)', position: 'relative', backgroundColor: '#EBEBEB', padding: '5px 10px', borderRadius: '4px', whiteSpace: "pre-line" }}>
              <span style={{ fontSize: '1rem !important', }}>
                {openAiData['DeploymentName']}
              </span>
            </div>
          </div>
        </div>
      </FormView>
      {/* <Schedule show={showSched} setShow={setShowSched} /> */}
      <GenWiz open={true} appconfig={gwconfig} />
    </>
  );
};

const reduxStatesData = (state) => ({
  serverList: state.servers.instancesNewTags,
  isloading: state.servers.isLoading
});

export default connect(reduxStatesData)(ServerManagement);